// Note: `process.env.MY_VARIABLE` get replaced at compile-time
const CONFIGURATION = {
  appUrl: process.env.APP_URL,
  graphql: process.env.GRAPHQL_URL,
  graphqlSubscriptionUrl: process.env.GRAPHQL_SUBSCRIPTION_URL,
  registrationUrl: process.env.REGISTRATION_URL,
  loginUrl: process.env.LOGIN_URL,
  zesty: process.env.ZESTY_URL,
  grow: process.env.GROW_URL,
  investOnboardingUrl: process.env.INVEST_ONBOARDING_URL,
  laterOnboardingUrl: process.env.LATER_ONBOARDING_URL,
  checkingOnboardingUrl: process.env.CHECKING_ONBOARDING_URL,
  mocOnboardingUrl: process.env.MOC_ONBOARDING_URL,
  earlyOnboardingUrl: process.env.EARLY_ONBOARDING_URL,
  longReopenUrl: process.env.LONG_REOPEN_URL,
  hdyhauUrl: process.env.HDYHAU_URL,
  productOnboardingUrl: process.env.PRODUCT_ONBOARDING_URL,
  supportUrl: process.env.SUPPORT_URL,
  earlyGiftUrl: process.env.EARLY_GIFT_URL,
  growArticleRedirectsUrl: process.env.GROW_ARTICLE_REDIRECTS_URL,

  plaidEnv: process.env.PLAID_LINK_ENV,

  googleMapsKey: process.env.GOOGLE_MAPS_KEY,
  googleRecaptchaSiteKey: process.env.GOOGLE_RECAPTCHA_SITEKEY,
  googleAnalytics: process.env.GOOGLE_ANALYTICS_ID,

  rudderStackWriteKey: process.env.RUDDER_STACK_WRITE_KEY,
  rudderStackDataPlaneUrl: process.env.RUDDER_STACK_DATA_PLANE_URL,

  braze: process.env.BRAZE_API_KEY,
  brazeSdkUrl: process.env.BRAZE_SDK_URL,

  head: process.env.HEAD,
  release: process.env.RELEASE_TAG || '',
  buildEnv: process.env.BUILD_ENV,

  graphqlBatchingEnabled: process.env.GRAPHQL_BATCHING_ENABLED ?? 'false',

  socureSdkKey: process.env.SOCURE_SDK_KEY,

  salesforceScriptSrc: process.env.SALESFORCE_SCRIPT_SRC,
  salesforceOrgId: process.env.SALESFORCE_ORG_ID,
  salesforceBaseLiveAgentUrl: process.env.SALESFORCE_BASE_LIVE_AGENT_URL,
  salesforceScrt2Url: process.env.SALESFORCE_SRCT2URL,
}

// Workaround due to how parcel interpolates env variables
if (!CONFIGURATION.release) {
  CONFIGURATION.release = ''
}

export { CONFIGURATION }
